import { Injectable } from '@angular/core';
import * as Routes from 'src/Routes';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class PanneServices {

  constructor(private http: HttpClient) { }
  post(formData: FormData): Promise<any> {
    return this.http.post<any>(Routes.PANNE, formData).toPromise();
  }

  update(formData: FormData, id): Promise<any> {
    return this.http.post<any>(`${Routes.PANNE}/${id}`, formData).toPromise();
  }

  delete(id: number) {
    return this.http.delete(`${Routes.PANNE}/${id}`).toPromise();

  }

  find(id: number): Promise<any> {
    return this.http.get<any>(`${Routes.PANNE}/${id}`).toPromise();
  }

  add(formData: FormData): Promise<any> {
    return this.http.post<any>(`${Routes.PANNE}`, formData).toPromise();
  }

  all(): Promise<any> {
    return this.http.get<any>(`${Routes.PANNE}`).toPromise();
  }
  public gets(page) {
    return this.http.get<any>(`${Routes.PANNE}?page=${page}`)
      .toPromise();
  }

  public get(url) {
    return this.http.get<any>(`${url}`)
      .toPromise();
  }
  public getvehicle() {
    return this.http.get<any>(`${Routes.VEHICULEALL}`)
      .toPromise();
  }
  public getMissions() {
    return this.http.get<any>(`${Routes.MISSION}`)
      .toPromise();
  } 
  public getBreakdownByAuto(page, vehicle_id){
    return this.http.get<any>(`${Routes.PANNE}?page=${page}&vehicle_id=${vehicle_id}`)
      .toPromise();
  }
}
